import React, { useEffect, useRef, useState } from 'react';
import { FiSettings } from 'react-icons/fi';
import {
  ADMIN_THEME_DEFAULTS,
  ADMIN_THEME_PRESETS,
  loadAdminTheme,
  saveAdminTheme,
} from './adminUiPrefs';

const COLOR_FIELDS = [
  { key: 'primary', label: 'Primary' },
  { key: 'bg', label: 'Page' },
  { key: 'sidebarBg', label: 'Sidebar' },
  { key: 'cardBg', label: 'Cards' },
  { key: 'toggleOn', label: 'Toggle' },
];

const AdminThemeMenu = ({ scope = 'admin' }) => {
  const [open, setOpen] = useState(false);
  const [theme, setTheme] = useState(() => loadAdminTheme(scope));
  const wrapRef = useRef(null);

  useEffect(() => {
    const onDoc = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const apply = (next) => {
    const saved = saveAdminTheme(next, scope);
    setTheme(saved);
  };

  return (
    <div className="admin-theme-menu" ref={wrapRef}>
      <button
        type="button"
        className="header-icon-btn"
        title="Theme colors"
        aria-label="Theme colors"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <FiSettings />
      </button>
      {open && (
        <div className="admin-theme-popover" role="dialog" aria-label="Admin theme colors">
          <p className="admin-theme-popover__title">Theme color</p>
          <div className="admin-theme-presets">
            {ADMIN_THEME_PRESETS.map((preset) => (
              <button
                key={preset.id}
                type="button"
                className="admin-theme-preset"
                onClick={() => apply({ ...preset.theme, hideHeader: theme.hideHeader === true })}
              >
                <span style={{ background: preset.theme.primary }} />
                {preset.label}
              </button>
            ))}
          </div>
          <button
            type="button"
            className={`admin-theme-hide${theme.hideHeader === true ? ' is-on' : ''}`}
            aria-pressed={theme.hideHeader === true}
            onClick={() => apply({ ...theme, hideHeader: theme.hideHeader !== true })}
          >
            Hide Header
            <span>{theme.hideHeader === true ? 'ON' : 'OFF'}</span>
          </button>
          <div className="admin-theme-fields">
            {COLOR_FIELDS.map((field) => (
              <label key={field.key}>
                {field.label}
                <input
                  type="color"
                  value={theme[field.key] || ADMIN_THEME_DEFAULTS[field.key]}
                  onChange={(e) => apply({ ...theme, [field.key]: e.target.value })}
                  aria-label={field.label}
                />
              </label>
            ))}
          </div>
          <button
            type="button"
            className="admin-theme-reset"
            onClick={() => apply({ ...ADMIN_THEME_DEFAULTS })}
          >
            Reset colors
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminThemeMenu;
